import { ReactNode } from 'react'
import styled from '@emotion/styled'

const L5ConceptRoot = styled.div({
	display: 'contents',
})

interface L5ConceptProps {
	cid: string
	// dirItemId: number|null
	children?: ReactNode
}

const L5Concept = ({cid, children}: L5ConceptProps) => {
	return (
		<L5ConceptRoot data-cid={cid}>
			{children}
		</L5ConceptRoot>
	)
}

export default L5Concept
